import containerFuild from '../../description/html-snippets/container-fuild.js';
import css from '../css-snippets/section-card-cedrow-benefits-policy.js';
const html = `
<div
  class="wrap-blocks-benefits"
  data-attribute="blocks-benefits"
  data-use-border="true"
  data-color-border="#123123"
  style="--use-border: true; --color-border: #123123"
>
  <div data-attribute="heading-benefit" class="heading-benefit">
    <div data-attribute="title-benefits" class="title-benefits">Benefis</div>
    <div class="arrow-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>chevron-down</title>
        <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" fill="currentColor" />
      </svg>
    </div>
  </div>
  <div data-attribute="toggle-block" class="toggle-block">
    <!-- compare -->
    <div data-show="true" data-attribute="block-compare" class="block-compare">
      <div
        data-background-color-before="#fff5f5"
        data-text-color-before="#6b7280"
        data-attribute="before"
        class="block-label"
        style="--bg-color-before: #fff5f5; --text-color-before: #6b7280"
      >
        <div data-attribute="title-before" class="title-label">Traditional Braces</div>
        <div data-attribute="list-item-before" class="list-item-label">
          <div data-attribute="item-before" class="item-label">
            <div data-attribute="wrap-image-item-before" class="wrap-item-label">
              <img
                data-attribute="img-item-before"
                src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a729e9c72ce8e51771d9d0a.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-before" class="text-item-label">Feel rigid, heavy, and restrictive</div>
          </div>
          <div data-attribute="item-before" class="item-label">
            <div data-attribute="wrap-image-item-before" class="wrap-item-label">
              <img
                data-attribute="img-item-before"
                src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a729e9c72ce8e51771d9d0a.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-before" class="text-item-label">Feel rigid, heavy, and restrictive</div>
          </div>
          <div data-attribute="item-before" class="item-label">
            <div data-attribute="wrap-image-item-before" class="wrap-item-label">
              <img
                data-attribute="img-item-before"
                src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a729e9c72ce8e51771d9d0a.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-before" class="text-item-label">Feel rigid, heavy, and restrictive</div>
          </div>
        </div>
      </div>

      <div
        class="label-vs"
        data-attribute="vs"
        data-bg-color-vs="#00374c"
        data-text-color-vs="#ffffff"
        style="--bg-color-vs: #00374c; --text-color-vs: #ffffff"
      >
        VS
      </div>

      <div
        data-background-color-after="#f3f7fe"
        data-text-color-after="#6b7280"
        data-attribute="after"
        class="block-label"
        style="--bg-color-after: #f3f7fe; --text-color-after: #6b7280"
      >
        <div data-attribute="title-after" class="title-label">Cedrow</div>
        <div data-attribute="list-item-after" class="list-item-label">
          <div data-attribute="item-after" class="item-label">
            <div data-attribute="wrap-image-item-after" class="wrap-item-label">
              <img
                data-attribute="img-item-after"
                src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a729fdd2d69eca21259ad27.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-after" class="text-item-label">Lightweight and comfortable</div>
          </div>
          <div data-attribute="item-after" class="item-label">
            <div data-attribute="wrap-image-item-after" class="wrap-item-label">
              <img
                data-attribute="img-item-after"
                src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a729fdd2d69eca21259ad27.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-after" class="text-item-label">Lightweight and comfortable</div>
          </div>
          <div data-attribute="item-after" class="item-label">
            <div data-attribute="wrap-image-item-after" class="wrap-item-label">
              <img
                data-attribute="img-item-after"
                src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a729fdd2d69eca21259ad27.png"
                alt=""
              />
            </div>
            <div data-attribute="text-item-after" class="text-item-label">Lightweight and comfortable</div>
          </div>
        </div>
      </div>
    </div>

    <!-- feature -->
    <div data-show="true" data-attribute="block-feature" class="block-feature">
      <div data-attribute="list-item-feature" class="list-item-feature">
        <div data-attribute="item-feature" class="item-feature">
          <div data-attribute="wrap-image-item-feature" class="wrap-image-item-feature">
            <img
              data-attribute="img-item-feature"
              src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a72a8029f011cb41b7eb5b6.png"
              alt=""
            />
          </div>
          <div data-attribute="text-item-feature" class="text-item-feature">
            <h3>Low Profile Lift Design</h3>
            <p>
              A streamlined support system that fits comfortably inside all shoes without changing your normal fit or
              style.
            </p>
          </div>
        </div>
        <div data-attribute="item-feature" class="item-feature">
          <div data-attribute="wrap-image-item-feature" class="wrap-image-item-feature">
            <img
              data-attribute="img-item-feature"
              src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a72a8f4ed7bbb8dac98689c.png"
              alt=""
            />
          </div>
          <div data-attribute="text-item-feature" class="text-item-feature">
            <h3>Adaptive Dorsiflexion Strap</h3>
            <p>Gently assists foot lift while you walk, helping reduce toe dragging and improving step clearance.</p>
          </div>
        </div>
        <div data-attribute="item-feature" class="item-feature">
          <div data-attribute="wrap-image-item-feature" class="wrap-image-item-feature">
            <img
              data-attribute="img-item-feature"
              src="https://cdn.skyfastimg.com/images/2026/08/05/image-6a72a8f4ed7bbb8dac98689c.png"
              alt=""
            />
          </div>
          <div data-attribute="text-item-feature" class="text-item-feature">
            <h3>Secure and Adjustable Fit</h3>
            <p>
              Soft, breathable materials and adjustable straps keep the brace stable and comfortable throughout the day.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- block-feature-with-index -->
    <div
      data-show="true"
      data-bg-index="#eef2f3"
      data-color-text-index="#094a59"
      data-attribute="block-feature-with-index"
      class="block-feature-with-index"
      style="--bg-index: #eef2f3; --color-text-index: #094a59"
    >
      <div data-attribute="list-item-feature" class="list-item-feature">
        <div data-attribute="item-feature" class="item-feature">
          <div data-attribute="index-item-feature">1</div>
          <div data-attribute="text-item-feature" class="text-item-feature">
            <h3>Wrap</h3>
            <p>
              Place the soft ankle cuff around your lower leg, just above the ankle bone. Secure it comfortably using
              the strap.
            </p>
          </div>
        </div>
        <div data-attribute="item-feature" class="item-feature">
          <div data-attribute="index-item-feature">2</div>
          <div data-attribute="text-item-feature" class="text-item-feature">
            <h3>Attach</h3>
            <p>
              Connect the lift strap or buckle to your shoe laces or front anchor point so it aligns with the top of
              your foot.
            </p>
          </div>
        </div>
        <div data-attribute="item-feature" class="item-feature">
          <div data-attribute="index-item-feature">3</div>
          <div data-attribute="text-item-feature" class="text-item-feature">
            <h3>Adjust</h3>
            <p>Tighten the strap gently until your foot is supported in a natural lifted position.</p>
          </div>
        </div>
        <div data-attribute="item-feature" class="item-feature">
          <div data-attribute="index-item-feature">4</div>
          <div data-attribute="text-item-feature" class="text-item-feature">
            <h3>Walk</h3>
            <p>Take a few steps and fine-tune the tension so it feels secure, comfortable, and supportive.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- text hint -->
    <div
      data-show="true"
      data-attribute="text-hint"
      class="text-hint"
      data-bg-hint="#f3f7fe"
      data-text-hint="#6b7280"
      style="--bg-hint: #f3f7fe; --text-hint: #6b7280"
    >
      <p>
        Walk with greater confidence and support. Cedrow naturally supports your foot, reduces tripping risk, improves
        walking stability and regains confident movement without surgery or medications instantly.
      </p>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#00374c',
  topPadding: false,
  bottomPadding: false,
});
